import styled from "styled-components";

// 공통사용 START
export const BackgroundDiv = styled.div`
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  /* flex-flow: column; */
  /* height: 100vh; */
`;

export const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  /* flex: 1 0 0; */
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #eee;

  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
`;

export const ContentBody = styled.div`
  /* display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  margin-top: 40px; */

  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  align-self: stretch;
  overflow-y: auto;
  padding-bottom: 146px;
`;

export const NoticeText = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
`;

export const ContentBody2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const SelectDivArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const SelectedDiv = styled.div`
  display: flex;
  /* height: 64px; */
  /* padding: 0px 16px; */
  align-items: center;
  align-self: stretch;
  border-radius: 10px;
  /* background: "#fafafa"; */
  /* background: ${(props) => (props.activeData ? "#F0F0F0" : "#fafafa")}; */

  /* color: ${(props) => (props.active ? "#333" : props.activeData ? "#888" : "#AAA")}; */
  /* color: ${(props) => (props.active ? "#333" : "#888")}; */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const BottomBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #333;
  background: #333;

  color: var(--lara-button-button-text-color, #fff);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px; /* 121.429% */

  margin: 0 20px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 40px);
`;

export const BottomBtnArea = styled.div`
  margin: 0 20px;
  bottom: 24px;
  position: fixed;
  width: calc(100% - 40px);
`;
// 공통사용 END

// 의사정보 DIV
export const DoctorInfoDIv = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: ${(props) => (props.activeData ? "#E0E0E0" : "#f0f0f0")};
  margin-left: 8px;
`;
// 의사정보 DIV

// 진료 시간선택
export const DivSelectBoxArea = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const DivSelectBoxTitle = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
`;

export const DivSelectBox = styled.div`
  height: 100%;
  display: flex;
  padding: 10.5px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  /* border-radius: 6px; */
  border-radius: ${(props) => (props.viewYn ? "6px 6px 0px 0px" : "6px")};
  border: 1px solid #d0d0d0;
  border-bottom: ${(props) => (props.viewYn ? "0px solid #d0d0d0" : "1px solid #d0d0d0")};
  background: #fff;

  color: ${(props) => (props.defaultYn ? "#333" : "#000")};
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const DivSelectInBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  height: 50px;
`;

// export const SelectOptionBox = styled.ul`
//   display: ${(props) => (props.viewYn ? "flex" : "none")};
//   flex-direction: column;
//   align-items: flex-start;
//   align-self: stretch;

//   border-radius: 0px 0px 6px 6px;
//   border-right: 1px solid #d0d0d0;
//   border-bottom: 1px solid #d0d0d0;
//   border-left: 1px solid #d0d0d0;
//   background: #fff;

//   max-height: 168px;
//   overflow-y: auto;

//   position: absolute;
// `;

export const SelectOptionBox = styled.ul`
  display: ${(props) => (props.viewYn ? "flex" : "none")};
  border-top: 1px solid #d0d0d0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;

  border-radius: 0px 0px 6px 6px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
  border-left: 1px solid #d0d0d0;
  background: #fff;

  /* max-height: 168px; */
  max-height: 194px;
  overflow-y: auto;
  /* overflow-y: scroll; */

  position: absolute;

  /* ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #a9a9a9;
  } */
`;

export const SelectOption = styled.li`
  display: flex;
  padding: 10.5px 17.5px;
  align-items: center;
  gap: 7px;
  align-self: stretch;
`;

export const InnerDiv = styled.div`
  width: 100%;
`;

export const FlexDiv = styled.div`
  display: flex;
  height: 40px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const BtnRadio = styled.div`
  display: flex;
  width: 80px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 6px;
  /* background: ${(props) => (props.checked ? "#6A62E6" : "#F7F7F7")}; */
  background: ${(props) => (props.checked ? "#333333" : "#F7F7F7")};
  color: ${(props) => (props.checked ? "#FFFFFF" : "#888888")};
`;
// 진료 시간선택

// 증상입력 START
export const SelectDivBody = styled.div`
  display: flex;
  padding: 10.5px;
  align-items: center;
  gap: 10.5px;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid ${props => (props.err ? "#ff6259" : "#d0d0d0")};
  background: var(--lara-input-field-input-bg, #fff);
  height: 226px;
`;

export const InputText = styled.textarea`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  height: 226px;
  border: 0px;
  resize: none;
  overflow: auto;
  outline: none;
`;

export const ClickEventBtnArea = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 4px;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const ClickEventBtn = styled.label`
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: ${(props) => (props.clickStatus ? "#6A62E6" : "#f0f0f0")};
  color: ${(props) => (props.clickStatus ? "#fff" : "#000")};
`;

export const ImageDivArea = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const ImageBtnAdd = styled.div`
  display: flex;
  padding: 25px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #eee;
`;
// 증상입력 END

// 진료대상자 START
export const CaptureBtnArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  /* flex: 1 0 0; */
`;

export const CaptureBtn = styled.label`
  display: flex;
  padding: 20px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 10px;
  background: #fafafa;

  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const ReCaptureBtn = styled.label`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  background: #fafafa;

  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px; /* 100% */

  width: 32px;
  height: 12px;
  float: right;
  margin-top: 12px;
`;

export const NoticeTextArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const NoticeBoldText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
`;

export const NotiveSubText = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
`;

export const PreviewText = styled.div`
  margin-bottom: 8px;
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
`;
// 진료대상자 END

export const SettingBtn = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  background: #fafafa;
  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px; /* 100% */
  margin-left: auto;
`;

// 결제카드 START
export const Warapper = styled.div`
  width: 100%;
  border-radius: 10px;
  background: ${(props) => (props.disabledStatus ? "#F0F0F0" : "#fafafa")};
  input[type="radio"]:checked + label {
    background-color: #6a62e6 !important;
  }
`;

export const ListDiv = styled.label`
  display: flex;
  padding: 20px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  // background: ${(props) => (props.active ? "#6A62E6" : "#fafafa")};
`;

export const CardName = styled.div`
  color: ${(props) => (props.disabledStatus ? "#888" : props.active ? "#FFF" : "#333")};
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const CardNum = styled.div`
  color: ${(props) => (props.disabledStatus ? "#888" : props.active ? "#EEE" : "#888")};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;

export const CardErr = styled.div`
  color: #ff6259;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;
// 결제카드 END